class ApiConfig {

	static baseUrl = 'https://junior.gkq211.com/';
	static path = '';
	static uploadUrl = '';
	static uploadPath = '';
	static cdnUrl = "https://junior.gkq211.com";
	static staticImgUrl = ''; 

}

export default ApiConfig;